import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DeleteAccountDialog = ({
  open,
  onClose,
  onConfirm,
  account,
  loading = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'var(--ntb-bg-secondary)',
          borderRadius: '8px',
          boxShadow: '0 8px 32px var(--ntb-shadow-color)'
        }
      }}
    >
      <DialogTitle sx={{ 
        borderBottom: '1px solid var(--ntb-border-color)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ color: 'var(--ntb-text-primary)', fontWeight: 600 }}>
          Delete Account
        </Typography>
        <IconButton 
          onClick={onClose}
          sx={{ 
            color: 'var(--ntb-text-tertiary)',
            '&:hover': { 
              backgroundColor: 'var(--ntb-hover-bg)',
              color: 'var(--ntb-text-primary)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box>
          <Typography sx={{ color: 'var(--ntb-text-primary)', mb: 2 }}>
            Are you sure you want to delete the account "{account?.name}"?
          </Typography>
          <Typography sx={{ color: 'var(--ntb-text-tertiary)' }}>
            Warning: This will also delete all associated trade entries. This action cannot be undone.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, borderTop: '1px solid var(--ntb-border-color)' }}>
        <Button 
          onClick={onClose}
          disabled={loading}
          sx={{ 
            color: 'var(--ntb-text-tertiary)',
            '&:hover': { 
              backgroundColor: 'var(--ntb-hover-bg)',
              color: 'var(--ntb-text-primary)'
            },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{ 
            backgroundColor: 'var(--ntb-error-color)',
            '&:hover': { backgroundColor: '#d32f2f' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Delete Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog; 